import { render } from "./CertificatView.vue?vue&type=template&id=1794cb18&ts=true"
import script from "./CertificatView.vue?vue&type=script&lang=ts"
export * from "./CertificatView.vue?vue&type=script&lang=ts"

import exportComponent from "/workspaces/theokoel.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__